import { useGoalsContext } from './GoalsProvider';

export default useGoalsContext;
